import { render, staticRenderFns } from "./rec_fee_schdl.vue?vue&type=template&id=c8677b7a&scoped=true&"
import script from "./rec_fee_schdl.vue?vue&type=script&lang=js&"
export * from "./rec_fee_schdl.vue?vue&type=script&lang=js&"
import style0 from "./rec_fee_schdl.vue?vue&type=style&index=0&id=c8677b7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8677b7a",
  null
  
)

export default component.exports